/**
 * PageLayout
 *
 * Wraps routed pages in a consistent centered layout with shared width and
 * vertical spacing rules.
 * Used by most top-level pages such as landing, setup, dashboard, privacy, and
 * unsubscribe flows to keep page framing consistent.
 */

import React from 'react';
import { Container } from 'react-bootstrap';
import { useStyle } from '../../contexts/StyleContext';
import { SPACING } from '../../styling/DesignTokens';

interface PageLayoutProps {
  children: React.ReactNode;
  maxWidth?: string;
  topPadding?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  maxWidth = '900px',
  topPadding = '3%',
}) => {
  const { fontScheme } = useStyle();

  return (
    <Container
      fluid
      style={{
        marginTop: topPadding,
        fontFamily: fontScheme.BODY,
        overflowX: 'hidden',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: SPACING.XXL,
      }}
    >
      <div
        style={{
          flex: '1 0 auto',
          width: '100%',
          maxWidth,
          margin: '0 auto',
          paddingLeft: SPACING.LG,
          paddingRight: SPACING.LG,
          overflowX: 'hidden',
          boxSizing: 'border-box',
        }}
      >
        {children}
      </div>
    </Container>
  );
};

export default PageLayout;
